var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-pickr',{attrs:{"value":_vm.v,"config":_vm.config,"placeholder":_vm.placeholder,"name":_vm.name},on:{"on-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }